module.exports = __webpack_public_path__ + "img/mc.17d58b14.svg";